import { Box } from '@mui/material'

import ParticipantNote from 'components/ParticipantProfile/AddNote'
import { PROJECT_ADMIN_TYPE } from 'lib/authorization/Roles'

interface IProps {
  data: {
    adminType: string
  }
}

const ShowParticipantNote = (data: IProps | any) => {
  if (data.adminType === PROJECT_ADMIN_TYPE) return <></>

  return (
    <Box mt={4}>
      <ParticipantNote />
    </Box>
  )
}

export default ShowParticipantNote
